import { render, staticRenderFns } from "./VerAlertaBaseModal.vue?vue&type=template&id=4c60d7a6&"
import script from "./VerAlertaBaseModal.vue?vue&type=script&lang=ts&"
export * from "./VerAlertaBaseModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('4c60d7a6', component.options)
    } else {
      api.reload('4c60d7a6', component.options)
    }
    module.hot.accept("./VerAlertaBaseModal.vue?vue&type=template&id=4c60d7a6&", function () {
      api.rerender('4c60d7a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/ConfigurarBase/VerAlertaBaseModal.vue"
export default component.exports